import { cva } from "class-variance-authority"

export const scrollbarsCva = cva(["[scrollbar-width:thin]", "[scrollbar-color:var(--base-6)_transparent]"])
